import CloseIcon from "../../assets/svg/contact/cross.svg";
import ContactUs from "../../pages/contact";
import "./Drawer.scss";

export default function Drawer({ isOpen, onClose }) {
  return (
    <div>
      {isOpen && <div className="overlayContactDrawer" onClick={onClose}></div>}

      <div className={`drawer ${isOpen ? "open" : "closed"}`}>
        <div className="drawer-content">
          <button className="close-btn" onClick={onClose}>
            <img src={CloseIcon} alt="close" className="mb-1" />
          </button>
          <ContactUs />
        </div>
      </div>
    </div>
  );
}
